import { ApiStore, ApiStoreClass } from './api.store'

export interface GlobalStore {
  ApiStore: ApiStoreClass
}

export const useStores = (): GlobalStore => ({
  ApiStore,
})
